<template>
  <div class="header__user">
    <div class="header__dropdown">
      <div class="header__subline__container link link--text">
        <span class="header__user__name">
          {{ getProjectUserName }}
          <i class="icon icon-arrow-small"></i>
        </span>
        <span v-if="getUserBpStatus" class="header__subline">
          {{ $t(`common.${getUserBpStatus}`) }}
        </span>
      </div>
      <div class="header__dropdown__item link link--bg" @click="logOut">
        {{ $t("promo.header.logout") }}
        <i class="icon icon-arrow-big"></i>
      </div>
    </div>
  </div>
</template>
<script>
import ProjectRegisterMixin from "@libs/authorization/ProjectRegisterMixin";
import { mapGetters } from "vuex";

export default {
  name: "HeaderUser",

  mixins: [ProjectRegisterMixin],

  computed: {
    ...mapGetters("global", ["getUserBpStatus"]),
    getProjectUserName() {
      return this.$store.state.global.project_user.username;
    },
  },
};
</script>
